// mexicoV2Language.ts
// ─── Astria Mexico v2 — EN/ES language ──────────────────────────────────
// Follows the user's preferred language (utils/appLanguage.ts): ES when
// that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../../../utils/appLanguage";

export type MexicoV2Lang = "en" | "es";

const SUPPORTED: readonly MexicoV2Lang[] = ["en", "es"];
const ALIASES: Partial<Record<string, MexicoV2Lang>> = {};

const resolve = (appLanguage: string): MexicoV2Lang =>
  pickLanguage(appLanguage, SUPPORTED, ALIASES);

export const getMexicoV2Lang = (): MexicoV2Lang => resolve(getAppLanguage());

export function useMexicoV2Language(): MexicoV2Lang {
  return resolve(useAppLanguage());
}
